/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * link object
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdLink
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdLink {
    /**
     * destination_pin_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdLink
     */
    destinationPinId: number;
    /**
     * link_level integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdLink
     */
    linkLevel: number;
    /**
     * source_pin_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdLink
     */
    sourcePinId: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdLink interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdLink(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdLink {
    if (!('destinationPinId' in value) || value['destinationPinId'] === undefined) return false;
    if (!('linkLevel' in value) || value['linkLevel'] === undefined) return false;
    if (!('sourcePinId' in value) || value['sourcePinId'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdLinkFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdLink {
    return GetCharactersCharacterIdPlanetsPlanetIdLinkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdLink {
    if (json == null) {
        return json;
    }
    return {
        
        'destinationPinId': json['destination_pin_id'],
        'linkLevel': json['link_level'],
        'sourcePinId': json['source_pin_id'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdLinkToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdLink {
    return GetCharactersCharacterIdPlanetsPlanetIdLinkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdLinkToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'destination_pin_id': value['destinationPinId'],
        'link_level': value['linkLevel'],
        'source_pin_id': value['sourcePinId'],
    };
}

